import React from 'react';
import NewBillingPeriodButtonProperties from "./NewBillingPeriodButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import NewBillingPeriodStore from "./NewBillingPeriodStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./NewBillingPeriodButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import useOnEnterPress from '../../../hooks/EnterPress';
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import DatePickerSelect from '../../../ui_components/DatePickerSelect/DatePickerSelect';
import clsx from 'clsx';
import ArticleDescriptionInput from '../../Inputs/ArticleDescriptionInput/ArticleDescriptionInput';
import { useUserContext } from '../../../contexts/UserContext';
import Access from '../../Access/AllowAccess/Access';
// import MultiSelectOption from '../../../ui_components/MultiSelect/MultiSelectOption';

const NewBillingPeriodButton: React.FC<NewBillingPeriodButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  billingPeriodId,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT,
                                                                  customButton = null,
                                                                  agencyId
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new NewBillingPeriodStore(commonContext, billingPeriodId, agencyId);

    if (!userStore.hasAccess(Access.CREATE_BILLING_PERIOD.valueOf())) {
        return <></>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const setHourAndMinuteInEpoch = (originalEpoch: number, newHour: number, newMinute: number) => {
        const originalDate = new Date(originalEpoch);      
        originalDate.setHours(newHour);
        originalDate.setMinutes(newMinute);      
        return originalDate.getTime();
    }

    const onDescriptionChange = (newDescription: string) => store.billingPeriod.description = newDescription;
    const onStartDateChange = (newStartDate: number | undefined) => {
        store.billingPeriod.startDate = newStartDate ? setHourAndMinuteInEpoch(newStartDate, 0, 0) : 0;
    }
    const onEndDateChange = (newEndDate: number | undefined) => {
        store.billingPeriod.endDate = newEndDate ? setHourAndMinuteInEpoch(newEndDate, 23, 59) : 0;
    }

    const onBillingPeriodSave = async () => {
        const saved = await store.save();
        if (saved) {
            if (onSave) {
                onSave(store.billingPeriod);
            }
            store.closeModal();
        }
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useOnEnterPress(onBillingPeriodSave, [store]);

    const text = i18n.translate((store.isEditing ? "EDIT_BILLING_PERIOD" : "NEW_BILLING_PERIOD"));
    const btnIcon = store.isEditing ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;
    const Btn = () => {
        if (customButton != null) {
            return <div className={classes.custom_button_container} onClick={handleOnclick}>{customButton}</div>;
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal}
                       open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <div className={classes.display_flex}>
                            <DatePickerSelect label={'Inicio (dd/mm/yyyy)'} selectedValue={store.billingPeriod?.startDate} onChange={onStartDateChange}/>
                            <DatePickerSelect label={'Fin (dd/mm/yyyy)'} selectedValue={store.billingPeriod?.endDate} onChange={onEndDateChange}/>
                        </div>
                        <ArticleDescriptionInput className={clsx(classes.input, classes.flex_1)}
                            lines={5}
                            value={store.billingPeriod?.description}
                            onChange={onDescriptionChange}/>
                        <div className={classes.btn_container}>
                            <Button
                                loading={store.loading} className={classes.input} onClick={onBillingPeriodSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                            <Button
                                loading={store.loading} className={classes.cancel_btn} onClick={onCloseModal}
                                type={ButtonType.DEFAULT}
                                text={i18n.translate("CANCEL")}/>
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewBillingPeriodButton;
